<template>
	<v-dialog v-model="child_dialog" max-width="80%">
			<app-card>
				<app-section-loader :status="form_loader"></app-section-loader>
                <v-card-title>
				<h3>Cập nhật số {{ form.type === "E" ? "Điện" : "Nước" }} nội bộ - {{ form.consumer === "MG" ? "Máy giặt" : "Bảo vệ" }} - {{ form.description }}</h3>
			    </v-card-title>
				<h3 class="fs-14 grey--text">Cập nhật </h3>
				<v-form ref="form">
                    <v-container fluid>
                        <v-layout row wrap justify-center>
                            
                            <v-flex xs12 md3>
                                <v-text-field
                                    label="Số đầu kỳ"
                                    :disabled="loading.submit"
                                    v-model="form.start"
                                    prepend-icon="receipt"
                                    type="number"
                                    :rules="[value => value === null || value >= 0 || 'Giá trị phải >= 0']"                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 md3>
                                <v-text-field
                                    label="Số cuối kỳ"
                                    :disabled="loading.submit || !form.start"
                                    v-model="form.end"
                                    prepend-icon="receipt"
                                    type="number"
                                    :rules="[value => value === null || value >= 0 || 'Giá trị phải >= 0']"                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 md3>
                                <v-text-field
                                    label="Số đầu kỳ sau TĐH"
                                    :disabled="loading.submit || !form.end"
                                    v-model="form.start_after_change_counter"
                                    prepend-icon="receipt"
                                    type="number"
                                    :rules="[value => !value || value >= 0 || 'Giá trị phải >= 0']"                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 md3>
                                <v-text-field
                                    label="Số cuối kỳ sau TĐH"
                                    :disabled="loading.submit || !form.start_after_change_counter"
                                    v-model="form.end_after_change_counter"
                                    prepend-icon="receipt"
                                    type="number"
                                    :rules="[value => !value || value >= 0 || 'Giá trị phải >= 0']"                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 md4>
                                <v-text-field
                                    label="Tiêu thụ"
                                    :disabled="true"
                                    v-model="form.consumption"
                                    prepend-icon="receipt"
                                    type="number"
                                    :rules="[]"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 md8>
                                <v-text-field
                                    label="Ghi chú"
                                    :disabled="loading.submit"
                                    v-model="form.note"
                                    prepend-icon="event_note"
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-container>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn :disabled="loading.submit" @click="cancelInput">Trở về</v-btn>
                        <v-btn
                            :loading="loading.submit"
                            :disabled="loading.submit"
                            @click="submit"
                            color="primary"
                        >Cập nhật</v-btn>
                    </v-card-actions>
                </v-form>
			</app-card>
		</v-dialog>
</template>

<script>
import api from "Api";

export default {
	name: "dialog-cap-nhat-dien-nuoc-noi-bo",
	props: {
		dialog: Boolean,
        bill: Object,
	},
	data() {
		return {
			child_dialog: false,
			form_loader: false,
			form: {
                building: "",
                type: "",
                consumer_type: "",
                consumer: "",
                month: "",
                note: "",
            },
			loading: {
                submit: false
            },
			alert: {
                show: false,
                text: "",
                type: "error"
            },
		};
	},
	watch: {
        "form.end": function(nv, ov) {
			this.calculationConsumption();
		},
		"form.start": function(nv, ov) {
			this.calculationConsumption();
		},
        "form.end_after_change_counter": function(nv, ov) {
			this.calculationConsumption();
		},
		"form.start_after_change_counter": function(nv, ov) {
			this.calculationConsumption();
		},
		dialog(nv){
            if (nv && this.bill) {
                let form = {};                 
                for (const key in this.bill) {
                    form[key] = this.bill[key];
                }
                this.form = { ...form };
            }
			this.child_dialog = this.dialog;
		},
		child_dialog(nv) {
			this.$emit("changeDialogState", nv);
		},
	},
	methods: {
        calculationConsumption: function() {
            let consumption = 0;
            if (this.form.start && this.form.end) {
                consumption = this.form.end - this.form.start;
            }

            if (this.form.start_after_change_counter && this.form.end_after_change_counter) {
                consumption += this.form.end_after_change_counter - this.form.start_after_change_counter;
            }

            this.form.consumption = consumption;
		},
		cancelInput() {
			this.child_dialog = false;
            this.$refs.form.reset();
		},
		submit: async function() {
			if (!this.$refs.form.validate()) {
				swal.fire("Lỗi", "Vui lòng điền đầy đủ thông tin", "error");
			}

			this.loading = true;

			const postData = {
				...this.form,
			};

            delete postData.description;

			const data = await api.createOrEditInternalUtilityBill(postData);

			this.loading = false;

			if (data.status === 200) {
				this.child_dialog = false;
				this.$emit("getData");
				swal.fire("Thành công", data.data.message, "success");
			} else swal.fire("Lỗi", data.message, "error");
		},
	}
};
</script>
